/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".banner[_ngcontent-%COMP%]{position:fixed;top:0;width:100%;background:#34aba0;padding:.4rem;text-align:center;font-weight:700;z-index:1000}p[_ngcontent-%COMP%]{margin-bottom:5px!important}a[_ngcontent-%COMP%]{color:#f9f9f9!important}a[_ngcontent-%COMP%]:hover{color:#c2cec4!important}"];
export { styles as styles };
